"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Orbus Artwork Uploader
 * Artwork uploader, PDF preflight queue & processor.  Please refer to the [AWS Developer Guide](https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingRESTAPImpUpload.html) for multipart uploads.  The upload-related methods do not take file data themselves, rather they act as helper methods for using the AWS S3 APIs.  It is strongly recommended that you use Uppy and its [AWS S3 Multipart plugin](https://uppy.io/docs/aws-s3-multipart/) to assist with uploading files. The provided demo/example code offers a functioning example.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdobeSwitchApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class AdobeSwitchApi extends runtime.BaseAPI {
    /**
     * Accept result callback from adobe switch flow
     */
    callbackRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.Callback === null || requestParameters.Callback === undefined) {
                throw new runtime.RequiredError('Callback', 'Required parameter requestParameters.Callback was null or undefined when calling callback.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/adobe-switch/callback`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.CallbackToJSON(requestParameters.Callback),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Accept result callback from adobe switch flow
     */
    callback(Callback) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callbackRaw({ Callback: Callback });
        });
    }
}
exports.AdobeSwitchApi = AdobeSwitchApi;
